export default __webpack_public_path__ + "static/media/HLTC-USDT.0006d96d.svg";